export default {
  badge: 'Бадж',
  close: 'Затвори',
  dataIterator: {
    noResultsText: 'Няма намерени резултати',
    loadingText: 'Моля изчакайте...',
  },
  dataTable: {
    itemsPerPageText: 'Резултати на страница:',
    ariaLabel: {
      sortDescending: 'Низходящо сортиране.',
      sortAscending: 'Възходящо сортиране.',
      sortNone: 'Без сортиране.',
      activateNone: 'Премахни сортиране.',
      activateDescending: 'Активирай за низходящо сортиране.',
      activateAscending: 'Активирай за възходящо сортиране.',
    },
    sortBy: 'Сортирай по',
  },
  dataFooter: {
    itemsPerPageText: 'Резултати на страница:',
    itemsPerPageAll: 'Всички',
    nextPage: 'Следваща страница',
    prevPage: 'Предишна страница',
    firstPage: 'Начална страница',
    lastPage: 'Последна страница',
    pageText: '{0}-{1} от {2}',
  },
  datePicker: {
    itemsSelected: '{0} селектирани',
    nextMonthAriaLabel: 'Следващ месец',
    nextYearAriaLabel: 'Следваща година',
    prevMonthAriaLabel: 'Преден месец',
    prevYearAriaLabel: 'Предна година',
  },
  noDataText: 'Няма налични данни',
  carousel: {
    prev: 'Следващ',
    next: 'Предишен',
    ariaLabel: {
      delimiter: 'Слайд {0} от {1}',
    },
  },
  calendar: {
    moreEvents: '{0} още',
  },
  fileInput: {
    counter: '{0} файлове',
    counterSize: '{0} файлове ({1} общо)',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
  },
  pagination: {
    ariaLabel: {
      wrapper: 'Навигация',
      next: 'Следваща страница',
      previous: 'Предишна страница',
      page: 'Отиди на страница {0}',
      currentPage: 'Сегашна страница, Страница {0}',
    },
  },
  rating: {
    ariaLabel: {
      icon: 'Рейтинг {0} от {1}',
    },
  },
}
